import {
  Component,
  OnInit,
  ViewChild,
  AfterViewChecked,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import {
  phonePattern,
  WholesalersList,
  FacilityTypeChoices,
  Is340bOptions,
  solutionProvidersADict,
  FacilityTypesHydra,
} from 'src/app/shared/models/constants';
import {
  defaultRegistrationData,
  RegistrationData,
} from 'src/app/shared/models/registration';
import { pharmacy_default, Pharmacy } from 'src/app/shared/models/pharmacy';
import { RegistrationService } from 'src/app/shared/services/user/registration.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserService } from 'src/app/shared/services/user/user.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DirectService } from 'src/app/shared/services/user/direct.service';

@Component({
  selector: 'app-registration-admin-user',
  templateUrl: './registration-admin-user.component.html',
  styleUrls: ['./registration-admin-user.component.scss'],
})
export class RegistrationAdminUserComponent
  implements OnInit, AfterViewChecked
{
  @Input() vendor: any;
  @Input() vendorContent: any;
  @ViewChild('regForm') form: DxFormComponent;

  subs: Subscription = new Subscription();

  dea: any = { number: '', state: '' };

  dea_result: any;
  disableReferredBy = false;

  directBlackBox: any;
  showDirectBlackBox: any;

  deaButtonOptions: any = {
    text: 'Search',
    type: 'default',
    icon: 'search',
    useSubmitBehavior: true,
    disabled: false,
  };
  hydraEnabled = environment.hydraEnabled;

  password = 'password';
  passwordOptions: any = { mode: 'password', value: this.password };
  wholesaler = WholesalersList;
  facilityTypes =
    this.hydraEnabled && environment.supplierConfig.misc.facilityTypes.length
      ? environment.supplierConfig.misc.facilityTypes
      : FacilityTypeChoices;
  supplierCompanyName = environment.supplierConfig.supplierCompanyName;
  is340bOptions = Is340bOptions;

  paymentTypes = [
    {
      name: 'Credit Card',
      value: 'credit_card',
    },
    {
      name: 'ACH/Check',
      value: 'ach_check',
    },
  ];

  password_disabled = false;
  deaExist: any;

  cancel_disable_item = false;
  next_disable_item = true;

  buttonNextOptions: any = {
    text: 'Submit',
    type: 'default',
    useSubmitBehavior: true,
  };

  buttonCancelOptions: any = {
    text: 'Cancel',
    type: 'normal',
    useSubmitBehavior: false,
    onClick: () => {
      this.router.navigate(['/']);
    },
  };

  system_admin_user: any = {};

  customer: RegistrationData = JSON.parse(
    JSON.stringify(defaultRegistrationData),
  );
  pharmacy: Pharmacy = pharmacy_default;

  gpo_choices: {
    id: any;
    name: string;
    contract: string;
    user_terms: any;
    parent_id: any;
  }[] = [];
  sub_groups: {
    id: any;
    name: string;
    contract: string;
    user_terms: any;
    parent_id: any;
  }[] = [];
  gpo_sub_group_choices: {
    id: any;
    name: string;
    contract: string;
    user_terms: any;
    parent_id: any;
  }[] = [];
  gpo_choices_list = ['Yes', 'No'];
  terms: [];
  agree_or_not = 0;
  subGpoChoices: any;

  priorities = [
    { key: 1, name: 'I Agree to Terms' },
    { key: 2, name: 'I Will Print and Submit Executed Terms' },
  ];

  canSelectTerms = this.hydraEnabled;
  submit_disable_item = true;
  selectTermsOptions: any;
  priority: number;
  termsOptions: any;
  termsVisible = false;
  gpoSubGroupEnabled = false;
  showTermsOptions: any;
  showPrivacyOptions: any;
  hideMedProID = false;

  get gpoOtherEnabled() {
    return this.customer.company.gpo_name === 'Other';
  }

  get gpoTermsType() {
    if (
      [
        'Vizient',
        'Premier',
        'Capstone - Premier',
        'MTN States - Vizient',
        'Yankee Alliance - Premier',
        'Intalere',
      ].includes(this.customer.company.gpo_name)
    ) {
      return this.customer.company.gpo_name;
    }
    return 'Other';
  }

  get selectedGpo() {
    return this.gpo_choices.find(
      gpo => gpo.name === this.customer.company.gpo_name,
    );
  }

  errorMessage: string;
  selectedGPO = false;
  gpoOptions: any;

  dscsaOptions: any;

  subGpoOptions: any;

  loadingVisible = false;

  state_lic_to_upload: any[] = [];

  passwordRuleLower = /^(?=.*[a-z])/; // at least one lower case letter exists
  passwordRuleUpper = /^(?=.*[A-Z])/; // at least one upper case letter exists
  passwordRuleNumber = /^(?=.*[0-9])/; // at least one numeric
  passwordRuleSpSymbol = /^(?=.*[!@#$%^&*])/; // at least one special character

  phonePattern = phonePattern;

  termsTitle = 'Medigi Participation Agreement';
  termBlock: any;
  privacyBlocks: any;
  selectedPrivacyBlock: any;
  registrationHeader: any;
  privacyVisible = false;
  client = null;

  constructor(
    private registrationService: RegistrationService,
    private notificationService: NotificationService,
    private directService: DirectService,
    private userService: UserService,
    private datePipe: DatePipe,
    private router: Router,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  async ngOnInit() {
    try {
      await this.getDirectBlocks();
      await this.getMsClient();
    } catch (error) {
      console.log(error);
    }

    this.hydraEnabled
      ? this.setTermsOptionsBtn(false)
      : this.setTermsOptionsBtn(true);
    this.setPrivacyOptionsBtn();
    this.getRegistrationData();
    this.setSelectTermsOptions(this.canSelectTerms);
  }

  async getMsClient() {
    this.userService
      .getMsClient$()
      .subscribe(result => (this.client = result.data));
  }

  async getDirectBlocks() {
    const result = await this.directService.getDirectClient$().toPromise();
    this.registrationHeader = result.data.find(
      block => block.block_type === 'registration_header',
    );
    this.termBlock = result.data.find(
      block => block.block_type === 'terms_of_use',
    );
    this.privacyBlocks = result.data.filter(
      block => block.block_type === 'privacy_policy',
    );
    this.directBlackBox = result.data.find(x => x.block_type === 'blackbox');
    this.showDirectBlackBox = !!this.directBlackBox.body;
  }

  getRegistrationData() {
    this.registrationService.getRegistrationData().subscribe(
      result => {
        this.gpo_choices = result.data.gpo_choices;
        this.sub_groups = result.data.sub_groups;
        if (this.hydraEnabled) {
          this.terms = this.gpo_choices[0]?.user_terms.terms;
        }
      },
      error => (this.errorMessage = error),
    );
  }

  updateCustomer(data) {
    this.customer = JSON.parse(JSON.stringify(defaultRegistrationData));
    if (data) {
      this.dea_result = data;
      this.customer.company.name = data.name;
      this.customer.facility.name = data.name;

      if (data.dea_success) {
        this.customer.facility.delivery_address = data.dea_rec.address;
        this.customer.facility.dea_number = data.dea;
        this.customer.facility.dea_data = data;
      } else if (data.sl_success) {
        if (data.sl_rec.professionalDesignationFamily === 'PHMCY') {
          this.customer.company.name = data.sl_rec.name.last;
          this.customer.facility.name = data.sl_rec.name.last;
        }
        this.customer.facility.delivery_address = data.sl_rec.address;
      }

      this.customer.facility.is340b = false;
      this.customer.user.first_name = data.user.first_name;
      this.customer.user.last_name = data.user.last_name;
      this.customer.user.email = data.user.email;
      this.customer.user.phone = data.user.phone;

      if (this.vendor) {
        this.disableReferredBy = true;
        this.customer.company.referred_by = this.vendor;
      }

      this.setGpoOptions();
      this.hydraEnabled
        ? this.radioTermsOptions(true)
        : this.radioTermsOptions(false);
      this.setSelectTermsOptions(false);
      this.hideMedProID = true;

      this.dscsaOptions = {
        // IDs are only used by devextreme select box
        dataSource: solutionProvidersADict,
        displayExpr: 'name',
        valueExpr: 'name',
      };
    }
  }

  setGpoOptions() {
    this.gpoOptions = {
      dataSource: this.gpo_choices,
      displayExpr: 'name',
      valueExpr: 'name',
      onValueChanged: () => this.onGpoChanged(this.customer.company.gpo_name),
    };
  }

  setTermsOptionsBtn(disabled) {
    this.showTermsOptions = {
      width: 200,
      disabled: disabled,
      text: 'Show terms',
      type: 'default',
      useSubmitBehavior: false,
      onClick: () => (this.termsVisible = true),
    };
  }

  setPrivacyOptionsBtn() {
    this.showPrivacyOptions = {
      width: 140,
      disabled: false,
      text: 'Privacy Policy',
      type: 'default',
      useSubmitBehavior: false,
      onClick: () => (this.privacyVisible = true),
    };
  }

  showPrivacyBlock(block) {
    if (!block.body) {
      window.open(block.url, '_blank');
      return;
    }

    this.selectedPrivacyBlock = block;
    this.privacyVisible = true;
  }

  navigateToUrl(url) {
    window.open(url, '_blank');
  }

  onSubmit(e) {
    this.errorMessage = '';
    this.loadingVisible = true;
    var customer = JSON.parse(JSON.stringify(this.customer));
    customer.company.vendor_app = customer.company.vendor_app_str === 'Yes';
    customer.facility.bed_count = customer.facility.bed_count ?? null;
    customer.user.phone = customer.user.phone
      .replace('(', '')
      .replace(')', '')
      .replace(' ', '')
      .replace('-', '');
    if (
      customer.company.gpo_sub_group_name &&
      customer.company.gpo_sub_group_name !== 'None'
    ) {
      customer.company.gpo_name = customer.company.gpo_sub_group_name;
    }
    customer.facility.ap_invoice_email = !!customer.facility.ap_invoice_email
      ? customer.facility.ap_invoice_email
      : null;
    customer.facility.ap_invoice_name = !!customer.facility.ap_invoice_name
      ? customer.facility.ap_invoice_name
      : null;
    customer.facility.HIN = !!customer.facility.HIN
      ? customer.facility.HIN
      : null;

    customer.company.tax_id = !!customer.company.tax_id
      ? customer.company.tax_id
      : null;
    customer.company.dscsa_sol_provider = !!customer.company.dscsa_sol_provider
      ? customer.company.dscsa_sol_provider
      : null;
    customer.company.dscsa_contact_email = !!customer.company
      .dscsa_contact_email
      ? customer.company.dscsa_contact_email
      : null;
    customer.company.dscsa_contact_name = !!customer.company.dscsa_contact_name
      ? customer.company.dscsa_contact_name
      : null;
    customer.company.dscsa_contact_phone = !!customer.company
      .dscsa_contact_phone
      ? customer.company.dscsa_contact_phone
      : null;
    customer.company.referred_by = !!customer.company
        .referred_by
        ? customer.company.referred_by
        : null;
    customer.company.payment_option = !!customer.company
        .payment_option
        ? customer.company.payment_option
        : null;
    const steCustomer = JSON.stringify(customer);
    const formData = new FormData();
    formData.append('customer', steCustomer);
    if (this.state_lic_to_upload.length > 0) {
      formData.append('doc_sl', this.state_lic_to_upload[0]);
    }
    const s = this.registrationService.systemRegistration(formData).subscribe(
      () => {
        this.notificationService.showNotify(
          'Your Company and User have been Created',
          'success',
        );
        this.router.navigate(['/registration/thankyou/buyer']);
        this.loadingVisible = false;
        this.customer = JSON.parse(JSON.stringify(defaultRegistrationData));
      },
      error => {
        this.loadingVisible = false;
        this.errorMessage = error;
        this.radioTermsOptions(false);
        this.setSelectTermsOptions(false);
      },
    );
    this.subs.add(s);
    e.preventDefault();
  }

  onCancelClick() {
    this.router.navigate(['/']);
  }

  passwordComparison = () => {
    return this.customer.user.password;
  };

  onGpoChanged(gpoName) {
    this.gpo_sub_group_choices = this.sub_groups.filter(
      gpo => gpo.parent_id === this.selectedGpo?.id,
    );
    this.gpoSubGroupEnabled = false;
    if (this.gpo_sub_group_choices.length > 0) {
      this.customer.company.gpo_sub_group_name = 'None';
      this.gpoSubGroupEnabled = true;
      this.gpo_sub_group_choices.push({
        id: '',
        name: 'None',
        contract: '',
        user_terms: '',
        parent_id: '',
      });
    }
    if (!this.hydraEnabled) {
      this.terms = this.gpo_choices.find(
        gpo => gpo.name === gpoName,
      )?.user_terms.terms;
    }
    this.setSubGpoChoices();
  }

  setSubGpoChoices() {
    this.radioTermsOptions(false);
    this.setSelectTermsOptions(false);
    this.setTermsOptionsBtn(false);

    if (!this.hydraEnabled) {
      this.customer.terms.agree = false;
      this.customer.terms.terms = null;
    }

    this.subGpoChoices = {
      items: this.gpo_sub_group_choices,
      displayExpr: 'name',
      valueExpr: 'name',
      onValueChanged: () =>
        this.SubGpoChanged(this.customer.company.gpo_sub_group_name),
    };
    this.radioTermsOptions(true);
  }

  SubGpoChanged(subGpoName) {
    this.radioTermsOptions(false);
    this.setSelectTermsOptions(false);

    if (!this.hydraEnabled) {
      this.customer.terms.agree = false;
      this.customer.terms.terms = null;
      if (subGpoName === 'None') {
        this.terms = this.gpo_choices.find(
          gpo => gpo.name === this.customer.company.gpo_name,
        )?.user_terms.terms;
      } else {
        this.terms = this.gpo_sub_group_choices.find(
          gpo => gpo.name === subGpoName,
        )?.user_terms.terms;
      }
    }
    this.radioTermsOptions(true);
  }

  radioTermsOptions(selectRadio) {
    this.termsOptions = {
      disabled: !selectRadio,
      dataSource: this.priorities,
      displayExpr: 'name',
      valueExpr: 'key',
      onValueChanged: e => this.onRadioChanged(e),
    };
    if (!this.hydraEnabled) {
      this.termsOptions['hint'] = 'GPO must be set first';
    }
  }

  onRadioChanged(e) {
    this.agree_or_not = e.value;
    if (this.agree_or_not) {
      // if "I agree..." then can select terms
      if (this.agree_or_not === 1) {
        this.customer.terms.agree = true;
        this.setSelectTermsOptions(true);
      }
      // if "I will print..." then enable submit
      this.submit_disable_item = this.agree_or_not !== 2;
      this.priority = e.value;
      if (this.agree_or_not === 2) {
        this.customer.terms.agree = false;
        this.customer.terms.terms = null;
        this.setSelectTermsOptions(false);
      }
    }
  }

  setSelectTermsOptions(canSelectTerms) {
    let disabledInput = false;
    if (!this.hydraEnabled && !canSelectTerms && this.agree_or_not != 1) {
      disabledInput = true;
    }

    const valueExpr = this.hydraEnabled ? 'id' : 'rate';
    this.selectTermsOptions = {
      disabled: disabledInput,
      dataSource: this.terms,
      displayExpr: 'name',
      valueExpr: valueExpr,
      onValueChanged: e => this.onTermChanged(e),
    };
  }

  onTermChanged(e) {
    // if terms are selected then enable submit
    this.submit_disable_item = false;
    if (this.hydraEnabled && e.value > 0) {
      const selectedTerms: any = this.terms.find(
        term => term['id'] === e.value,
      );
      if (selectedTerms) {
        this.customer.terms.terms = selectedTerms.rate;
        this.customer.company.payment_option = selectedTerms.payment_option;
      }
    } else {
      this.customer.terms.terms = e.value;
    }
  }

  transformDate(date): string {
    return this.datePipe.transform(date, 'MM/dd/yyyy');
  }

  showPrivacy() {
    this.privacyVisible = true;
  }

  validateDSCSA(e) {
    if (this.hydraEnabled) {
      return true;
    } else {
      return !!e.value;
    }
  }
}
